import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { ExternalLink } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.css';

const DonateButton = ({ className }) => {
  const { t } = useTranslation();
  const presenter = usePresenter();

  return (
    <ExternalLink
      className={classNames(styles.container, className)}
      href={presenter.donationUrl}
      theme="secondary"
    >
      {t('channel_donate')}
    </ExternalLink>
  );
};

export default observer(DonateButton);
